import Vue from 'vue'
import cancelTransfomer from '@/transformers/taxReceipt/requestCancellation'

/**
 * @author José Luis R. <jose.ruiz@jbge.com.mx>
 *
 * Request cancellation of an invoice
 *
 * @param  payload
 * @return {Array} File's info
 */

const requestCancellation = payload =>
  Vue.$http.post('taxreceipt/cancellation-request/', cancelTransfomer.send(payload))
    .then()
    .catch((err) => {
      throw err
    })

export default requestCancellation


// WEBPACK FOOTER //
// ./src/services/taxReceipt/requestCancellation.js